export const addictionMedicine = {
  iconClassSuffix: "addictionmedicine",
  linkText: "Addiction",
  onClickProps: "Addiction Medicine",
};

export const antibiotic = {
  iconClassSuffix: "antibiotic",
  linkText: "Antibiotic",
  onClickProps: "Antibiotic",
};

export const boneandmetabolism = {
  iconClassSuffix: "boneandmetabolism",
  linkText: "Bone and Metabolism",
  onClickProps: "Bone and Metabolism",
};

export const cardiovascular = {
  iconClassSuffix: "cardiovascular",
  linkText: "Cardiovascular",
  onClickProps: "Cardiovascular",
};

export const dermatology = {
  iconClassSuffix: "dermatology",
  linkText: "Dermatology",
  onClickProps: "Dermatology",
};

export const developmentaldisability = {
  iconClassSuffix: "developmentaldisability",
  linkText: "Developmental Disability",
  onClickProps: "Developmental Disability",
};

export const diabetes = {
  iconClassSuffix: "diabetes",
  linkText: "Diabetes",
  onClickProps: "Diabetes",
};

export const fatigue = {
  iconClassSuffix: "fatigue",
  linkText: "Fatigue",
  onClickProps: "Fatigue",
};

export const gastrointestinal = {
  iconClassSuffix: "gastrointestinal",
  linkText: "Gastrointestinal",
  onClickProps: "Gastrointestinal",
};

export const liverdisorders = {
  iconClassSuffix: "liverdisorders",
  linkText: "Liver Disorders",
  onClickProps: "Liver Disorders",
};
export const neurology = {
  iconClassSuffix: "neurology",
  linkText: "Neurology",

  onClickProps: "Neurology",
};
export const oralanddental = {
  iconClassSuffix: "oralanddental",
  linkText: "Oral and Dental",
  onClickProps: "Oral and Dental",
};

export const painandanalgesia = {
  iconClassSuffix: "painandanalgesia",
  linkText: "Pain and Analgesia",

  onClickProps: "Pain and Analgesia",
};

export const palliativecare = {
  iconClassSuffix: "palliativecare",
  linkText: "Palliative Care",

  onClickProps: "Palliative Care",
};

export const psychotropic = {
  iconClassSuffix: "psychotropic",
  linkText: "Psychotropic",
  onClickProps: "Psychotropic",
};

export const respiratory = {
  iconClassSuffix: "respiratory",
  linkText: "Respiratory",
  onClickProps: "Respiratory",
};

export const rheumatology = {
  iconClassSuffix: "rheumatology",
  linkText: "Rheumatology",
  onClickProps: "Rheumatology",
};

export const sexualandreproductivehealth = {
  iconClassSuffix: "sexualandreproductivehealth",
  linkText: "Sexual and Reproductive Health",
  onClickProps: "Sexual and Reproductive Health",
};

export const toxicologyandtoxinology = {
  iconClassSuffix: "toxicologyandtoxinology",
  linkText: "Toxicology and Toxinology",
  onClickProps: "Toxicology and Toxinology",
};

export const ulcerandwoundmanagement = {
  iconClassSuffix: "ulcerandwoundmanagement",
  linkText: "Ulcer and Wound Management",
  onClickProps: "Ulcer and Wound Management",
};

export const wildernessmedicine = {
  iconClassSuffix: "wildernessmedicine",
  linkText: "Wilderness Medicine",
  onClickProps: "Wilderness Medicine",
};

export const quicklinks = {
  iconClassSuffix: "quicklinks",
  linkText: "Pregnancy and Breastfeeding",
  onClickProps: "Pregnancy and Breastfeeding",
};

export const guidelineList = [
  addictionMedicine,
  antibiotic,
  boneandmetabolism,
  cardiovascular,
  dermatology,
  developmentaldisability,
  diabetes,
  fatigue,
  gastrointestinal,
  liverdisorders,
  neurology,
  oralanddental,
  painandanalgesia,
  palliativecare,
  psychotropic,
  respiratory,
  rheumatology,
  sexualandreproductivehealth,
  toxicologyandtoxinology,
  ulcerandwoundmanagement,
  wildernessmedicine,
  quicklinks,
];

export const mpstopicfile = {
  Addiction_Medicine: {
    text: "Addiction",
    topicfile: "alcohol-drug-problems",
    mpsguidelineid: 34,
    bannerclass: "book-addiction",
    topiccode: "amg1-c",
    mobheader: "rgb(18, 72, 81)",
    squareIconClass: addictionMedicine.iconClassSuffix,
    onClickProps: "Addiction Medicine",
  },
  Antibiotic: {
    text: "Antibiotic",
    topicfile: "bartonella-infections",
    mpsguidelineid: 3,
    bannerclass: "book-antibiotic",
    topiccode: "abg16-c",
    mobheader: "rgb(247, 174, 173)",
    squareIconClass: antibiotic.iconClassSuffix,
    onClickProps: "Antibiotic",
  },
  Bone_and_Metabolism: {
    text: "Bone and Metabolism",
    topicfile: "thyroid-disorders-overview",
    mpsguidelineid: 28,
    bannerclass: "book-bone",
    topiccode: "bmg2-c",
    mobheader: "rgb(188, 191, 0)",
    squareIconClass: boneandmetabolism.iconClassSuffix,
    onClickProps: "Bone and Metabolism",
  },
  Cardiovascular: {
    text: "Cardiovascular",
    topicfile: "cardiovascular-disease-risk-stratification",
    mpsguidelineid: 4,
    bannerclass: "book-cardiovascular",
    topiccode: "cvg7-c",
    mobheader: "rgb(155, 125, 186)",
    squareIconClass: cardiovascular.iconClassSuffix,
    onClickProps: "Cardiovascular",
  },
  Dermatology: {
    text: "Dermatology",
    topicfile: "acne",
    mpsguidelineid: 5,
    bannerclass: "book-dermatology",
    topiccode: "dmg-c",
    mobheader: "rgb(149, 135, 113)",
    squareIconClass: dermatology.iconClassSuffix,
    onClickProps: "Dermatology",
  },
  Developmental_Disability: {
    text: "Developmental Disability",
    topicfile: "cerebral-palsy",
    mpsguidelineid: 33,
    bannerclass: "book-developmental",
    topiccode: "ddg4-c",
    mobheader: "rgb(63, 196, 183)",
    squareIconClass: developmentaldisability.iconClassSuffix,
    onClickProps: "Developmental Disability",
  },
  Diabetes: {
    text: "Diabetes",
    topicfile: "other-types-of-diabetes",
    mpsguidelineid: 26,
    bannerclass: "book-diabetes",
    topiccode: "dbg1-c",
    mobheader: "rgb(255, 244, 82)",
    squareIconClass: diabetes.iconClassSuffix,
    onClickProps: "Diabetes",
  },
  Fatigue: {
    text: "Fatigue",
    topicfile: "fatigue-introduction",
    mpsguidelineid: 17,
    bannerclass: "book-fatigue",
    topiccode: "ftg-c",
    mobheader: "rgb(66, 65, 67)",
    squareIconClass: fatigue.iconClassSuffix,
    onClickProps: "Fatigue",
  },
  Gastrointestinal: {
    text: "Gastrointestinal",
    topicfile: "disorders-oesophagus",
    mpsguidelineid: 7,
    bannerclass: "book-gastrointestinal",
    topiccode: "gig-c",
    mobheader: "rgb(0, 84, 159)",
    squareIconClass: gastrointestinal.iconClassSuffix,
    onClickProps: "Gastrointestinal",
  },
  Liver_Disorders: {
    text: "Liver Disorders",
    topicfile: "abnormal-liver-biochemistry",
    mpsguidelineid: 32,
    bannerclass: "book-liver",
    topiccode: "ldg1-c",
    mobheader: "rgb(70, 10, 104)",
    squareIconClass: liverdisorders.iconClassSuffix,
    onClickProps: "Liver Disorders",
  },
  Neurology: {
    text: "Neurology",
    topicfile: "acute-management-of-seizures-and-status-epilepticus",
    mpsguidelineid: 8,
    bannerclass: "book-neurology",
    topiccode: "nrg5-c",
    mobheader: "rgb(236, 9, 40)",
    squareIconClass: neurology.iconClassSuffix,
    onClickProps: "Neurology",
  },
  Oral_and_Dental: {
    text: "Oral and Dental",
    topicfile: "dental-caries",
    mpsguidelineid: 9,
    bannerclass: "book-oral",
    topiccode: "dtg3-c",
    mobheader: "rgb(139, 131, 215)",
    squareIconClass: oralanddental.iconClassSuffix,
    onClickProps: "Oral and Dental",
  },
  Other: {
    text: "Other",
    topicfile: "anaphylaxis",
    mpsguidelineid: 24,
    bannerclass: "book-other",
    topiccode: "oth-c",
    mobheader: "rgb(221, 222, 223)",
    onClickProps: "Other",
  },
  Pain_and_Analgesia: {
    text: "Pain and Analgesia",
    topicfile: "understanding-pain",
    mpsguidelineid: 2,
    bannerclass: "book-pain",
    topiccode: "agg7-c",
    mobheader: "rgb(0, 164, 229)",
    squareIconClass: painandanalgesia.iconClassSuffix,
    onClickProps: "Pain and Analgesia",
  },
  Palliative_Care: {
    text: "Palliative Care",
    topicfile: "palliative-care-overview",
    mpsguidelineid: 10,
    bannerclass: "book-palliative",
    topiccode: "pcg4-c",
    mobheader: "rgb(186, 224, 202)",
    squareIconClass: palliativecare.iconClassSuffix,
    onClickProps: "Palliative Care",
  },
  Psychotropic: {
    text: "Psychotropic",
    topicfile: "delirium",
    mpsguidelineid: 11,
    bannerclass: "book-psychotropic",
    topiccode: "ptg8-c",
    mobheader: "rgb(0, 162, 97)",
    squareIconClass: psychotropic.iconClassSuffix,
    onClickProps: "Psychotropic",
  },
  Respiratory: {
    text: "Respiratory",
    topicfile: "asthma-introduction-and-diagnosis",
    mpsguidelineid: 19,
    bannerclass: "book-respiratory",
    topiccode: "rsg6-c",
    mobheader: "rgb(253, 191, 87)",
    squareIconClass: respiratory.iconClassSuffix,
    onClickProps: "Respiratory",
  },
  Rheumatology: {
    text: "Rheumatology",
    topicfile: "gout",
    mpsguidelineid: 12,
    bannerclass: "book-rheumatology",
    topiccode: "rhg3-c",
    mobheader: "rgb(242, 105, 34)",
    squareIconClass: rheumatology.iconClassSuffix,
    onClickProps: "Rheumatology",
  },
  Sexual_and_Reproductive_Health: {
    text: "Sexual and Reproductive Health",
    topicfile: "sterilisation",
    mpsguidelineid: 27,
    bannerclass: "book-sexual",
    topiccode: "srg2-c",
    mobheader: "rgb(147, 55, 87)",
    squareIconClass: sexualandreproductivehealth.iconClassSuffix,
    onClickProps: "Sexual and Reproductive Health",
  },
  Toxicology_and_Toxinology: {
    text: "Toxicology and Toxinology",
    topicfile: "what-is-covered-in-toxicology-toxinology",
    mpsguidelineid: 30,
    bannerclass: "book-toxicology",
    topiccode: "ttg1-c",
    mobheader: "rgb(65, 83, 99)",
    squareIconClass: toxicologyandtoxinology.iconClassSuffix,
    onClickProps: "Toxicology and Toxinology",
  },
  Ulcer_and_Wound_Management: {
    text: "Ulcer and Wound Management",
    topicfile: "fundamentals-of-ulcer-and-wound-management",
    mpsguidelineid: 14,
    bannerclass: "book-ulcer",
    topiccode: "lwg2-c",
    mobheader: "rgb(137, 212, 223)",
    squareIconClass: ulcerandwoundmanagement.iconClassSuffix,
    onClickProps: "Ulcer and Wound Management",
  },
  Wilderness_Medicine: {
    text: "Wilderness Medicine",
    topicfile: "altitude-illness",
    mpsguidelineid: 31,
    bannerclass: "book-wilderness",
    topiccode: "wmg1-c",
    mobheader: "rgb(188, 189, 192)",
    squareIconClass: wildernessmedicine.iconClassSuffix,
    onClickProps: "Wilderness Medicine",
  },
  quicklinks: {
    text: "Drug use in pregnancy and breastfeeding",
    topicfile: "altitude-illness",
    mpsguidelineid: 31,
    bannerclass: "book-wilderness",
    topiccode: "wmg1-c",
    mobheader: "rgb(188, 189, 192)",
    squareIconClass: quicklinks.iconClassSuffix,
    onClickProps: "Pregnancy and Breastfeeding",
  },
};